Ext.define('SA.view.CountAdjuster', {
    statics: {
        create() {
            return new SA.view.CountAdjuster();
        }
    },

    constructor() {
        this.fns = {};
        this.counts = {};
    },

    apply() {
        var excess = Math.max(0, this.counts.current - this.counts.target),
            shortfall = Math.max(0, this.counts.target - this.counts.current);

        for (let i = 0; i < excess; i++) {
            this.fns.decrementFn();
        }

        for (let i = 0; i < shortfall; i++) {
            this.fns.incrementFn();
        }
    },

    currentCount(currentCount) {
        this.counts.current = currentCount;
        return this;
    },

    decrementFn(decrementFn) {
        this.fns.decrementFn = decrementFn;
        return this;
    },

    incrementFn(incrementFn) {
        this.fns.incrementFn = incrementFn;
        return this;
    },

    targetCount(targetCount) {
        this.counts.target = targetCount;
        return this;
    }
});